import { render, staticRenderFns } from "./FlowCategoryForm.vue?vue&type=template&id=36580dd0"
import script from "./FlowCategoryForm.vue?vue&type=script&lang=js"
export * from "./FlowCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports